var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('div',[_c('InformationIcon')],1),_c('transition',{attrs:{"name":"tooltip"}},[_c('div',{staticClass:"info-box"},[_c('div',{staticClass:"info-text"},[_vm._v(" "+_vm._s(_vm.informationText)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }